<template>
  <div :style="baseStyle">
    <div style="width: 0; height: 0; position: relative" v-if="editorMode">
      <div :style="glassSize"
           class="gridEditorGlass"
           @keydown.stop=""
           ref="editorGlass">
      </div>
    </div>

    <div ref="anchor"
         @keydown.stop=""
         @keyup.stop=""
         @keypress.stop=""
         @mousedown.stop=""
         @click.stop="">
      <div v-if="editorMode">
        <div ref="cellEditor"
             :style="cellEditorPos + 'max-width:calc(100vw - 4); min-width:100px;'">
          <!--          <div style="display: block" class="cellEditorArrow">-->
          <!--            <font-awesome-icon icon="angle-up" transform="grow-10 right-2 down-4" ></font-awesome-icon>-->
          <!--          </div>-->
          <div v-if="arrowPosition === 'up'"
               :style="'padding-left:' + editArrowLeft +'; display: block; font-size: 21px;margin: 0; line-height: 14px;'"
               class="cellEditorArrow">
            ▲
          </div>
          <div class="cellEditor" ref="cellEditorBody" style="margin-left: -45px"
               @focusout="editorFocusOut"
               @keydown="editorKeyDown"
               tabindex="0"
          ></div>
          <div v-if="arrowPosition === 'down'"
               :style="'padding-left:' + editArrowLeft +'; display: block; font-size: 21px;margin: 0; line-height: 10px;'">
            ▼
          </div>

        </div>
      </div>
    </div>
    <div v-if="!v3" ref="holder" :style="'display: ' + (v3 ? 'none' : 'block')">
<!--    <div ref="holder" :style="'display: ' + (v3 ? 'none' : 'block')">-->
      <div style="position: relative; width: 0; height: 0; z-index: 10;" v-if="showMultiSelect">
        <div style="position: absolute; left:3px; width: 20px" class="border-info select-deselect-btn">
          <div>
            <b-button ref="allBtn" variant="plm-toolbar-primary" class="mini-toolbar-btn" @click="selectMultiselectAll">
              <font-awesome-icon icon="square-check"></font-awesome-icon>
            </b-button>
            <b-button ref="noneBtn" variant="plm-toolbar-primary" class="mini-toolbar-btn"
                      @click="selectMultiselectNone">
              <font-awesome-icon icon="square-dashed"></font-awesome-icon>
            </b-button>
          </div>
        </div>
      </div>
      <v-grid
          :class="headerSizeClass"
          ref="dg"
          theme="material"
          :resize="true"
          :readonly="true"
          :source="filteredRows"
          :columns="renderedColumns"
          :pinnedBottomSource="dataForSummaryRow"
          :useClipboard="false"
          @beforeSortingApply="_beforeSort"
      >
      </v-grid>
    </div>

    <div v-if="v3" ref="v3Holder">
      <div style="position: relative; width: 0; height: 0; z-index: 910;" v-if="showMultiSelect">
        <div style="position: absolute; left:0px; width: 20px" class="border-info select-deselect-btn">
          <div>
            <b-button ref="allBtn" variant="plm-toolbar-primary" class="mini-toolbar-btn" style="height: 20px" @click="selectMultiselectAll">
              <font-awesome-icon icon="square-check" transform="up-2"></font-awesome-icon>
            </b-button>
            <b-button ref="noneBtn" variant="plm-toolbar-primary" class="mini-toolbar-btn"
                      style="height: 20px"
                      @click="selectMultiselectNone">
              <font-awesome-icon icon="square-dashed" transform="up-3"></font-awesome-icon>
            </b-button>
          </div>
        </div>
      </div>
      <base-grid
          ref="baseGrid"
          :source="filteredRows"
          :streamingEngine="streamingEngine"
          @apply-filter="applyFilter"
          :form="form"
          :context="context"
          :eligibleFields="eligibleFields"
          :columns="renderedColumns"
          :active-col-id="activeColId"
          :multiSelectVisible="showMultiSelect"
          :pinned-columns="pinnedCols + (selectMode === 'range' && showMultiSelect ? 1 : 0)"
          :streaming="streaming"
          :edit-on="editable"
          @searchOn="onSearchOn"
          @searchOff="onSearchOff"
          @markReadyToShow="markReadyToShow"
          :pinned-bottom-source="dataForSummaryRow"
          @rowSelected="v3RowSelected"
          @rowDoubleClick="v3RowDoubleClick"
          @noActiveCol="noActiveCol"
          @activateCol="activateCol"
          @cellFocus="v3CellFocus"
          @cancelEdit="cancelEdit"
         >
      </base-grid>
    </div>

    <b-container>
      <b-row>
        <b-col cols="12">
          <div class="d-none" ref="filters">
            <slot></slot>
          </div>
        </b-col>
      </b-row>
      <b-row class="p0 m0 no-gutters" style="height: 0px">
        <b-col cols="12">
          <div class="d-none" ref="headerBarNest">
            <GridHeader ref="gridHeader"
                        :primary-visible="showAdd"
                        :secondary-visible="showDetails"
                        :show-delete="showDelete"
                        :show-reload="headerShowReload"
                        :active-col-id="activeColId"
                        :show-search="headerShowSearch"
                        :primary-enabled="addEnabled"
                        :show-columns="showColumns"
                        :editMultiSelectFromTab.sync="editMultiSelectFromTab"
                        :search-on="searchOn"
                        :column-data="columnData"

                        :secondary-enabled="selectionSize === 1 &&
                        !(localSelectedItem && localSelectedItem.__row_conf ? localSelectedItem.__row_conf.readOnly : false)"

                        :delete-enabled="deleteEnabled && canDelete && selectionSize > 0 &&
                        !(localSelectedItem && localSelectedItem.__row_conf ? localSelectedItem.__row_conf.readOnly : false)"

                        @secondary-click="secondaryClick"
                        @primary-click="primaryClick"
                        @delete-click="deleteClick"
                        @searchOn="onSearchOn"
                        @searchOff="onSearchOff"
                        @noActiveCol="noActiveCol"
                        @open-branding="openBranding"
                        @clearClicked="clearClicked"
                        :toolbox="toolbox"
                        :form="form"
                        :selection-size="selectionSize"
                        :selectionSize.sync="selectionSize"
                        :multiSelectEnabled="selectMode=='range'"
                        :showMultiSelect.sync="showMultiSelect"
                        @showMultiSelect="setShowMultiSelect"
            >
              <template v-slot:primaryButtons>
                <div class="d-none" data-header-slot="primaryButtons"></div>
                <slot name="primaryButtons"></slot>
              </template>
              <template v-slot:toolButtons>
                <slot name="toolButtons"></slot>
              </template>
              <template v-slot:secondToolButtons>
                <div class="d-none" data-header-slot="secondToolButtons"></div>
                <slot name="secondToolButtons"></slot>
              </template>

              <template v-slot:middleButtons>
                <div class="d-none" data-header-slot="middleButtons"></div>
                <slot name="middleButtons"></slot>
              </template>

              <template v-slot:dangerButton>
                <div class="d-none" data-header-slot="dangerButton"></div>
                <slot name="dangerButton"></slot>
              </template>

            </GridHeader>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <div class="d-none" ref="lockerIcon">
      <div style="position: relative; width: 0; height: 0">
        <div style="position: absolute; left:-9px; top: -8px">
          <font-awesome-icon icon="lock" transform="shrink-3 left-3 up-3"></font-awesome-icon>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

import VGrid, {VGridVueTemplate} from "@entestat/vue-datagrid";
import _ from 'lodash';
import Vue from "vue";
import GridHeader from "@/components/datagrid/GridHeader";
import {ColumnsManager} from "@/components/datagrid/ColumnsManager";
import {VirtualArray} from "@/components/datagrid/VirtualArray";
import {nextTick} from "@/utils/Executors";
import ReachInput from "@/components/inputs/ReachInput";
import {addListener, removeListener} from "resize-detector";
import SingleExecution from "@/utils/SingleExecution";
import {LocalNotification, showLocalNotification} from "@/components/notifications/LocalNotification";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import RtModule from "@/utils/RtModule";
import {cloneEntity} from "@/utils/Objects";
import FormsAI from "@/components/forms/FormsAI";
import Rpc from "@/Rpc";
import {
  checkIfThereAreDynamicFieldsOnTheGrid,
  getFilteredRecordsFromDatabaseWithRows,
  getAllRecordsFromDatabaseWithDynamicCells,
  getAllRecordsFromDatabaseWithDynamicColumns,
  isEqual, getAllRecordsFromDatabaseWithRows, getRecordsFromDatabaseWithRowsWhenStreaming
} from "@/components/forms/customizations/plm/DynamicColumnsService";
import GridCellEditor from "@/components/forms/GridCellEditor.vue";
import DefaultCellTextRenderer from "@/components/datagrid/DefaultCellTextRenderer.vue";
import SessionManager from "@/utils/SessionManager";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import BaseGrid from "@/components/baseGrid/BaseGrid.vue";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import ProductWCLElements from "@/server/com/silkplm/model/plm/ProductWCLElements";
import DataStream from "@/components/forms/DataStream";

export default {
  name: "DataGrid2",
  components: {BaseGrid, GridHeader, ReachInput, VGrid},
  async mounted() {

    this.showMultiSelect = this.context?.multiSelect;
    this._initGrid();
    this.colsVersion++;
    //window['__lastGrid__'] = this;

    setTimeout(() => {
      if (this.recordsWithChosenFilters) {
        this.selectRange()
      }
    }, 300);
    document.addEventListener('backbutton', this.onBackButton, false);
  },

  async created() {
    this.v3 = SessionManager.hasFlag(FeatureFlag.GRID_V3);

    if(window['_mem_bombs']) {
      this.bomb = new ArrayBuffer(30 * 1024 * 1024);
      console.log("Bomb!!!!");
    }
    /**
     * @type {StreamingEngine}
     */
    this.streamingEngine = null;

    this.colsEditor = {};
    //window.lastGrid = this;
    this.searchGuard = new SingleExecution();
    /** @type {function(Object):Boolean | null} */
    this.beforCellCommit = null;

    this.subOnEventCancelHidingGridCellEditor = false;

    if (await checkIfThereAreDynamicFieldsOnTheGrid(this.form) && !this.form.streamingMode) {
      await this.loadDynamicData();
    }

  },

  unmounted() {
    if (this.sizeListener) {
      if(this.$refs.holder) {
        removeListener(this.$refs.holder, this.sizeListener);
      }
    }

  },
  beforeDestroy() {
    document.removeEventListener('backbutton', this.onBackButton, false);
  },
  methods: {
    onSearchOn(col = null){
      this.columnData = col;
      this.$emit("set-col-for-search", col);
      this.searchOn = true;
      this.$refs.gridHeader.setFocusForLoop();
    },
    onSearchOff(){
      this.searchOn = false;
      this.$emit("set-col-for-search", null);
      this.clearQuery();
    },
    clearClicked(){
      this.multiColumntQuery = [];
      console.log("Clearing multicol search");
    },
    async refreshDynamicColumns() {
      let columnsManager = this._getColumnsManager();
      columnsManager.resetConfigForDynamicColumns();
      await this.loadDynamicData();
    },

    noActiveCol() {
      this.activeColId = null;
      this.columnData = null;
      this.searchOn = false;
    },

    activateCol(col) {
      this.activeColId = col;
    },

    setShowMultiSelect(v) {
      if (this.streamingEngine?.dataStream?.metaRenderers) {
        this.streamingEngine.dataStream.metaRenderers = new Set();
      }
      this.showMultiSelect = v;
    },
    _countWords(str) {
      return str.trim().split(' ').filter(x => x != '').length
    },

    _setHeaderClass(renderedColumns) {

      let labelsWordsNumber = [];

      renderedColumns.forEach(col => {
        const numberOfWords = this._countWords(col.name);
        labelsWordsNumber.push(numberOfWords);
      });

      labelsWordsNumber = labelsWordsNumber.sort((a, b) => b - a);
      const longestLabelWordsNumber = labelsWordsNumber[0];

      return (longestLabelWordsNumber > 5) ? 'large-header' : ((longestLabelWordsNumber >= 3 && longestLabelWordsNumber <= 5) ? 'medium-header' : 'small-header');
    },

    _initGrid() {
      if (this.v3) {
        this._constructV3();
        return;
      }
      this.click1 = -1;
      this.click2 = -1;
      if (!this.$el ||
          !this.$refs?.gridHeader ||
          !this.$el.getElementsByTagName ||
          !this.$el.getElementsByTagName("revogr-focus") ||
          !this.$el.getElementsByTagName("revogr-focus")[0]) {
        window.requestAnimationFrame(() => {
          this._initGrid()
        });
      } else {
        this._construct();
      }
    },
    onKeyDown(event) {
      if (this.v3) {
        this.$refs.baseGrid?.rowKeyDown(event);
      }
    },
    getAltGridSelection() {
      let all = this.$el.getElementsByTagName("revogr-focus");
      if (all.length > 1) {
        return all[1];
      }
      return null;
    },
    getGridSelection() {
      let all = this.$el.getElementsByTagName("revogr-focus");
      if (all.length > 0) {
        return all[0];
      }
      return null;
    },

    //add classes to vertical and horizontal scrollbars
    addClassesToScrollbars() {
      let scrolls = this.$el.getElementsByTagName("revogr-scroll-virtual");

      if (scrolls[0].classList.contains("vertical")) {
        let cls = ['app-scroll-bar', 'app-scroll-bar-vertical'];
        scrolls[0].classList.add(...cls);
      }

      if (scrolls[1].classList.contains("horizontal")) {
        let cls = ['app-scroll-bar', 'app-scroll-bar-horizontal'];
        scrolls[1].classList.add(...cls);
      }
    },

    _construct() {

      /**
       * @type {VGrid|Vue}
       */
      this.gridComponent = this.$el.getElementsByTagName("revo-grid")[0];
      this.gridComponent.addEventListener('click', () => {
        this.gridClick();
      });
      this.grid = this.$el;
      this.gridSelection = this.$el.getElementsByTagName("revogr-focus")[0];
      this.gridData = this.$el.getElementsByTagName("revogr-data")[0];
      this.dataStore = this.gridData.dataStore;


      this.headerWrapper = this.$el.getElementsByClassName("header-wrapper")[0];
      this.gridOverlaySelections = this.$el.getElementsByTagName("revogr-overlay-selection");

      if (this.gridOverlaySelections.length > 1) {
        this.gridOverlaySelection = this.gridOverlaySelections[1];
        this.gridOverlaySelections[1].addEventListener("itemDblClick", (item) => {
          this._itemDoubleClick();
        });
      } else {
        this.gridOverlaySelection = this.gridOverlaySelections[0];
        this.gridOverlaySelections[0].addEventListener("itemDblClick", (item) => {
          this._itemDoubleClick();
        });

      }

      this.gridOverlaySelection.addEventListener("itemClick", (item) => {
        this._focusCell(item);
      });

      // this.gridOverlaySelection.addEventListener("focusCell", (item) => {
      //   console.log("xx");
      //   this._focusCell(item);
      // });

      this.holder = this.$refs['holder'];

      this.addClassesToScrollbars();

      let headerMountPoint = document.createElement("div");
      this.$el.prepend(headerMountPoint);


      this.gridHeader = this.$refs.gridHeader;
      // if (!this.gridHeader) {
      // }

      headerMountPoint.appendChild(this.gridHeader.$el);
      this.$nextTick(() => {
        this.gridHeader.installInGrid(this);
      });

      this.gridHeader.$mount(headerMountPoint);

      let filters = this.$refs["filters"];
      this.gridHeader.injectFilters(filters);
      this.gridHeader.filtersColsClasses = this.filtersColsClasses;
      filters.classList.remove("d-none");

      if (!this.showHeader) {
        this.gridHeader.classList.add("d-none");
      }

      if (this.rowStyle) {
        this.gridData.rowStyle = this.rowStyle;
      }
      if (this.rowFormatter) {
        this.gridData.rowFormatter = this.rowFormatter;
      }

      setTimeout(() => {
        this.reinstallObserver();
      });

      this._getColumnsManager().multiSelectEnabled = (this.selectMode === 'range' && this.showMultiSelect);
      this._getColumnsManager().postConstruct();


      this.filteredItems.attach(this);
      if (this.multiSelectAutoOn) {
        this.gridHeader.turnOnMultiSelect();
      }
    },
    _constructV3() {
      let headerMountPoint = document.createElement("div");
      this.$el.prepend(headerMountPoint);

      this.gridHeader = this.$refs.gridHeader;
      // if (!this.gridHeader) {
      // }

      headerMountPoint.appendChild(this.gridHeader.$el);
      this.$nextTick(() => {
        this.gridHeader.installInGrid(this);
      });

      this.gridHeader.$mount(headerMountPoint);

      let filters = this.$refs["filters"];
      this.gridHeader.injectFilters(filters);
      this.gridHeader.filtersColsClasses = this.filtersColsClasses;
      filters.classList.remove("d-none");

      if (!this.showHeader) {
        this.gridHeader.classList.add("d-none");
      }

      if (this.rowStyle) {
        this.gridData.rowStyle = this.rowStyle;
      }
      if (this.rowFormatter) {
        this.gridData.rowFormatter = this.rowFormatter;
      }

      this._getColumnsManager().multiSelectEnabled = (this.selectMode === 'range' && this.showMultiSelect);
      this._getColumnsManager().postConstruct();
      this.filteredItems.attach(this);
    },

    applyFilter(colTable, result) {
      this.$emit('apply-filter', colTable, result);
    },

    getGridHeaderCols() {
      // zadokowane kolumny mają osobne grupy headerów -dotytyczy to multiedycji
      let groups = this.$el.getElementsByTagName("revogr-header");
      if (groups.length == 1) {
        return groups[0];
      }
      if (groups.length > 1) {
        return groups[1];
      }
    },

    reinstallObserver() {
      let observer = {
        get: (val) => {
        },
        set: (k, val, oldVal) => {
          if (k === 'focus' || k === "range") {
            if (!this.focusEventQueued) {
              this.focusEventQueued = true;
              setTimeout(() => this._updateSelection());
            }
          }
        },
        reset: () => {
          if (!this.focusEventQueued) {
            this.focusEventQueued = true;
            setTimeout(() => this._updateSelection());
          }
        },
      }
      setTimeout(() => {
        this.getGridSelection()?.selectionStore?.use(observer);
        this.getAltGridSelection()?.selectionStore?.use(observer);
      });
    },

    fixGlassSize(el) {
      if (this.editorMode && this.$refs?.holder) {
        const x = this.$refs.holder.offsetWidth;
        const y = this.$refs.holder.offsetHeight;
        const nSize = `width:${x}px; height:${y}px`;
        if (this.glassSize != nSize) {
          this.glassSize = nSize;
          //console.log(nSize);
        }
      }
    },

    gridClick() {
      this.click1 = this.click2;
      this.click2 = performance.now();
    },

    _getColumnsManager() {
      if (!this.columnsManager) {
        this.columnsManager = new ColumnsManager(this);
        this.columnsManager.multiSelectEnabled = this.selectMode === "range" && this.showMultiSelect;
      }
      return this.columnsManager;
    },

    async selectRange() {
      if (this.streaming) {
        this.filteredRows = await Rpc.Forms.listExtendedEntities(this.form.formClassLong);
      }
      this.filteredRows.forEach(item => {
        if (!item.__meta__) {
          item.__meta__ = {}
        }
        for (let filterItem of this.recordsWithChosenFilters) {
          if (filterItem.EID === item.EID) {
            item.__meta__.selected = true;
          }
        }
      });
      this._updateRangeSelection();
      this.$emit("refresh-meta-rq");
    },

    selectMultiselectAll() {
      if (this.streamingEngine) {
        this.streamingEngine.selectAll();
        return;
      }
      this.filteredRows.forEach(item => {
        if (!item.__meta__) {
          item.__meta__ = {}
        }
        item.__meta__.selected = true;
      });
      this._updateRangeSelection();
      this.$refs.allBtn.blur();
      this.$emit("refresh-meta-rq");
    },

    selectMultiselectNone() {
      if (this.streamingEngine) {
        this.streamingEngine.unselectAll();
        this.resetSelectonAndVScroll();
        return;
      }

      this.filteredRows.forEach(item => {
        if (!item.__meta__) {
          item.__meta__ = {}
        }
        item.__meta__.selected = false;
      });
      this._updateRangeSelection();
      if (this.$refs.noneBtn) {
        this.$refs.noneBtn.blur();
      }
      this.$emit("refresh-meta-rq");
    },

    elementSelectionChange(element, newSelectionStatus) {
      if (this.selectMode === "range" && this.showMultiSelect) {
        return this._updateRangeSelection();
      }

      this._updateSelection(true);
      if (newSelectionStatus) {
        this.$emit('row-selected', element);
        this.$emit('rows-selected', this.localSelectedItems);

        this.$emit('row-index-selected', element);
        this.$emit('rows-indices-selected', this.localSelectedIndices);
      }
    },

    // async search(q) {
    //
    //   this.selectMultiselectNone();
    //   await this.searchGuard.scheduleExecution(q?.toLowerCase(), async () => {
    //     if (this.streaming) {
    //       if (!this.multiColumntQuery) {
    //         this.multiColumntQuery = [];
    //       }
    //
    //       if(this.columnData) {
    //         // wybrano jakas kolumne
    //
    //         let found = false;
    //         for (let entry of this.multiColumntQuery) {
    //           if (entry.col.id === this.columnData.id) {
    //             entry.text = q;
    //             found = true;
    //             break;
    //           }
    //         }
    //         if (!found) {
    //           this.multiColumntQuery.push({
    //             text: q,
    //             col: this.columnData
    //           })
    //         }
    //
    //         if (this.multiColumntQuery.length <=1){
    //           // jedna kolumna
    //           await this.streamingEngine.filterByText(q?.toLowerCase(), this.columnData);
    //           this.gridHeader.lastQuery = q;
    //         } else {
    //           // wiele kolumn
    //           await this.streamingEngine?.filterByManyTexts(this.multiColumntQuery);
    //           this.gridHeader.lastQuery = q;
    //         }
    //       } else {
    //         // wyszukanie ogolne
    //         await this.streamingEngine.filterByText(q?.toLowerCase(), this.columnData);
    //         this.gridHeader.lastQuery = q;
    //       }
    //     } else {
    //       await this.filteredItems.filterByText(q?.toLowerCase(), this.columnData);
    //       this.gridHeader.lastQuery = q;
    //     }
    //   });
    //   this.$emit("search", this.filteredItems.data);
    // },

    async search(q) {
      this.selectMultiselectNone();
      await this.searchGuard.scheduleExecution(q?.toLowerCase(), async () => {
        if (this.streaming) {
          await this.streamingEngine.filterByText(q?.toLowerCase(), this.columnData);
          this.gridHeader.lastQuery = q;
        } else {
          await this.filteredItems.filterByText(q?.toLowerCase(), this.columnData);
          this.gridHeader.lastQuery = q;
        }
      });
      this.$emit("search", this.filteredItems.data);
    },


    /**
     * @param {Function} pk
     */
    focusOn(predicate) {
      setTimeout(() => this.filteredItems.focusOn(predicate));
    },

    focusOnIndex(rowIndex) {
      setTimeout(() => this.filteredItems.focusOnIndex(rowIndex));
    },

    focusOnRow(row) {
      setTimeout(() => this.filteredItems.focusOnRow(row));
    },

    /**
     * @param {Function} pk
     */
    highlight(predicate) {
      setTimeout(() => this.filteredItems.focusOn(predicate, false));
    },

    highlightIndex(rowIndex) {
      setTimeout(() => this.filteredItems.focusOnIndex(rowIndex, false));
    },

    highlightRow(row) {
      setTimeout(() => this.filteredItems.focusOnRow(row, false));
    },

    async openBranding() {
      let product = new ProductInSeason();
      await product.load(this.localSelectedItem.productInSeasonId);
      let wcl = await product.getProductWCLElements();
      await FormsLoader.showForm(ProductWCLElements, {
        mode: 'EDIT',
        entityId: wcl.id})
    },

    secondaryClick() {
      this.$emit("details", this.selectedItem);
    },
    primaryClick() {
      this.$emit("add", this.selectedItem);
    },
    deleteClick() {
      this.$emit("delete", this.selectedItem);
    },

    clearQuery(){
      this.$refs.gridHeader?.clearQuery();
      this.multiColumntQuery = [];
      console.log("Clearing multicol search")
    },

    afterDeleteEntity() {
      this.localSelectedItems = null;
      this.selectionSize = 0;
    },

    /**
     * @param {Function} callback
     */
    setRowsStyle(callback) {
      if (this.gridData) {
        this.gridData.rowStyle = callback;
      } else {
        this.rowStyle = callback;
      }
    },

    /**
     * @param {Function} callback
     */
    setRowsClass(callback) {
      if (this.gridData) {
        this.gridData.rowFormatter = callback;
      } else {
        this.rowFormatter = callback;
      }
    },

    v3RowDoubleClick(row) {
      nextTick(() => {
        this._itemDoubleClick();
      });
    },

    markReadyToShow() {
      this.$emit("markReadyToShow")
    },

    v3RowSelected(row) {

      this.focusEventQueued = false;

      if (this.selectMode === "range" && this.showMultiSelect) {
        this._updateRangeSelection();
        return;
      }

      if (row == null) {

        this.localSelectedItem = null;
        this.localSelectedItems = null;
        this.localSelectedIndex = null;
        this.localSelectedIndices = null;
        this.selectionSize = 0;
        this.$emit("update:selectionSize", this.selectionSize);
        this._updateCanDelete();

        this.$emit('selection-clear', this.selectedItem);
      } else {

        this.localSelectedItem = row.data;
        this.localSelectedItems = [row.data];

        this.localSelectedIndex = row.index;
        this.localSelectedIndices = [row.index];

        this.selectionSize = this.localSelectedItems.length;
        this.$emit("update:selectionSize", this.selectionSize);
        this._updateCanDelete();

        this.$emit('row-selected', this.localSelectedItem);
        this.$emit('rows-selected', this.localSelectedItems);

        this.$emit('row-index-selected', this.localSelectedIndex);
        this.$emit('rows-indices-selected', this.localSelectedIndices);

        this.selectionModel = null;
      }

      if (this.selectMode === "single") {
        this.selectionModel = this.localSelectedItem;
      } else {
        this.selectionModel = this.localSelectedItems;
      }

      nextTick(() => {
        this.$emit('update:selectedItem', this.localSelectedItem);
        this.$emit('update:selectedItems', this.localSelectedItems);

        this.$emit('update:selectedIndex', this.localSelectedIndex);
        this.$emit('update:selectedIndices', this.localSelectedIndices);

        this.$emit('model-change', this.selectionModel);
      });
    },


    async v3CellFocus(row, col, event) {
      if (row.data.__pending__) {
        return;
      }
      this._focusCell({row, col, cell: event.target?.parentNode}, true);
    },

    async _focusCell(item, v3 = false) {
      let col; // row number
      let colDef; // col config
      let row; // row number
      let rowData; // data
      let cell;

      if (v3) {
        row = item.row.index;
        rowData = item.row.data;
        colDef = item.col;
        col = this.columns.findIndex(c => c.colId === colDef.colId);
        cell = item.cell;

        if (colDef.dynamicColumn) {
          rowData = this._setItemFromDynamicColumns(colDef, rowData) ?? rowData;
        }
      }

      if (!v3) {
        let visibleColumns = [];

        for (let col of this.columnsManager.allColumns) {
          if (col.visible) {
            visibleColumns.push(col);
          }
        }

        cell = item.detail.mouseEvent.target;
        while (!cell.classList.contains('data-cell')) {
          cell = cell.parentElement;
          if (!cell) return;
        }

        for (let c of document.getElementsByClassName('data-cell')) {
          if (c != cell) {
            c.style.userSelect = 'none';
          }
        }

        cell.style.userSelect = 'text';

        col = item.detail.cell.x;
        colDef = visibleColumns[col];
        row = item.detail.cell.y;
        rowData = this._rowIndexToItem(row);

        if (colDef.dynamicColumn) {
          rowData = this._rowIndexAndColIndexToItemForDynamicColumns(colDef, row) ?? rowData;
        }
      }

      this.$emit("item-click", {col, colDef, row, rowData});

      if (this.localSelectedItems?.length > 1) {
        if (colDef.fieldConfig?.hasContextFilter && !colDef.fieldConfig.enableBulkEdit) {
          showLocalNotification(new LocalNotification($tr("cantMultiEdit", "Can't multi-edit"),
              $tr('dataGrid2.cannot.edit.multi', 'This field has an additional filter. You cannot edit it in multi-edit mode.')));
          return;
        }
        let src = this.localSelectedItems;
        if (this.localSelectedItems.materialize) {
          src = this.localSelectedItems.knownSelected;
        }
        for (let item of src) {
          let el = item[1];
          if (el?.__row_conf?.readOnly || !(el?.__supplement__?.editable ?? true)) {
            if (this.editable && colDef?.editorComponent) {
              showLocalNotification(new LocalNotification($tr("cantEdit", "Can't edit"),
                  $tr('dataGrid2.rows.read.only', 'Some rows are read only')));
            }
            return;
          }
          if (this.editable && colDef?.editorComponent) {
            if (el?.__supplement__?.lockedFields) {
              let lockedFields = el.__supplement__.lockedFields;
              for (let lockedField of lockedFields) {
                if (lockedField === colDef.fieldConfig.fieldName) {
                  showLocalNotification(new LocalNotification($tr("cantEdit", "Can't edit"),
                      $tr('dataGrid2.fields.read.only', 'Some fields are read only')));
                  return;
                }
              }
            }
          }
          if (colDef.fieldConfig?.visibleFunction || colDef.fieldConfig?.readOnlyFunction) {
            let isReadOnly = RtModule()[colDef.fieldConfig.readOnlyFunction].call(el, el, colDef.formConfig, null, null);
            if (isReadOnly) {
              showLocalNotification(new LocalNotification($tr("cantEdit", "Can't edit"),
                  $tr('dataGrid2.field.read.only', 'Field is read only')));
              return;
            }
          }
        }
      } else {
        if (rowData?.__row_conf?.readOnly || !(rowData?.__supplement__?.editable ?? true)) {
          if (this.editable && colDef?.editorComponent) {
            showLocalNotification(new LocalNotification($tr("cantEdit", "Can't edit"),
                $tr('dataGrid2.row.read.only\'', 'Row is read only')));
          }
          return;
        }
        if (this.editable && colDef?.editorComponent) {
          if (rowData?.__supplement__?.lockedFields) {
            let lockedFields = rowData.__supplement__.lockedFields;
            for (let lockedField of lockedFields) {
              if (lockedField === colDef.fieldConfig?.fieldName) {
                showLocalNotification(new LocalNotification($tr("cantEdit", "Can't edit"),
                    $tr('dataGrid2.field.read.only', 'Field is read only')));
                return;
              }
            }
          }
          if (colDef.fieldConfig?.visibleFunction || colDef.fieldConfig?.readOnlyFunction) {
            let isReadOnly = RtModule()[colDef.fieldConfig.readOnlyFunction].call(rowData, rowData, colDef.formConfig, null, null);
            if (isReadOnly) {
              showLocalNotification(new LocalNotification($tr("cantEdit", "Can't edit"),
                  $tr('dataGrid2.field.read.only', 'Field is read only')));
              return;
            }
          }
        }
      }
      if (this.showMultiSelect) {
        let clickedRow = _.find(this.localSelectedItems, {id: rowData.id});
        if (!clickedRow) {
          return;
        }
      }

      if (!this.editable) {
        return;
      }

      if (!colDef?.editorComponent) {
        return;
      }

      this.editorMode = true;

      const cellRct = cell.getBoundingClientRect();

      let clickX, clickY;
      if (v3) {
        clickX = cellRct.x + cellRct.width / 2;
        clickY = cellRct.y + cellRct.height / 2;
      } else {
        clickX = item.detail.mouseEvent.clientX;
        clickY = item.detail.mouseEvent.clientY;
      }
      const vpWidth = window.innerWidth;
      const vpHeight = window.innerHeight;
      const editorW = 320;
      const margin = 40;

      let editorLeft = clickX - editorW / 2;
      editorLeft = Math.max(editorLeft, margin);
      editorLeft = Math.min(editorLeft, vpWidth - editorW - margin);
      let offset = clickX - editorLeft;
      offset = Math.max(offset, margin);
      offset = Math.min(offset, editorW - margin);
      this.editArrowLeft = `${offset}px`;

      this.arrowPosition = 'up';
      let editorTop = clickY + 4;

      if (editorTop + 205 > vpHeight) {
        let delta = cellRct.top + 5;

        this.arrowPosition = 'down';
        this.cellEditorPos = `position:absolute; max-height:${delta - 4}px; left:${editorLeft}px; bottom:calc(100vh - ${delta}px);`
      } else {
        this.cellEditorPos = `position:absolute; max-height:calc(100vh - ${editorTop + 4}px); left:${editorLeft}px; top:${editorTop}px;`
      }

      this.editorConf = {
        cell: item.detail?.cell ?? {x: row, y: col},
        columnConfig: colDef,
        rowData: this.localSelectedItems?.length > 1 ? this.localSelectedItems : rowData,
        dataGrid: this,
        gridVirtualArray: this.filteredRows,
        streaming: this.streaming,
        streamingEngine: this.streamingEngine
      };

      if (colDef.editorComponent) {
        let clazz;
        if (this.colsEditor[colDef.prop]) {
          clazz = this.colsEditor[colDef.prop];
        } else {
          clazz = Vue.extend({...colDef.editorComponent, router: this.$router});
          this.colsEditor[colDef.prop] = clazz;
        }
        let rowDataCopy = cloneEntity(rowData);

        // to jest w 99% wypadkach (albo w 100) GridCellEditor - nie ma na razie innej implementacji
        let inst = new clazz({
          propsData: {
            cell: item.detail?.cell ?? {x: row, y: col},
            columnConfig: colDef,
            rowData: this.localSelectedItems?.length > 1 ? this.localSelectedItems : rowDataCopy,
            dataGrid: this,
            streaming: this.streaming,
            streamingEngine: this.streamingEngine,
            gridVirtualArray: this.filteredRows,
            customFocusOnHide: () => {
              this.$refs.cellEditorBody.focus();
              // console.log("custom focus capture");
            }
          }
        });

        this.cleanEditor();

        this.$children.push(inst);
        inst.$parent = this;
        inst.$root = this.$root;

        inst.$once("close", () => this.cancelEdit(true));
        inst.$once("commit", async (data) => {
          if (this.listOfDynamicPreparedObjectForColumns.length > 0) {
            let index = this.dynamicCells.findIndex(cell => cell.id === rowData.id);
            if (index !== -1) {
              let cellEntityFromDatabase = await Rpc.Forms.getEntity(this.form.dynamicCells, rowData.id).lock();
              this.dynamicCells[index] = cellEntityFromDatabase;
            }
          }
          this.commitEdit(data);
        });

        this.editorInst = inst;

        if (!this.anchor) {
          this.anchor = this.$refs.anchor;
        }

        if (!this.subOnEventCancelHidingGridCellEditor) {
          this.$onEvent(Events.cancelHidingGridCellEditor, (editMode) => {
            this.subOnEventCancelHidingGridCellEditor = true;
            this.cancelHidingGridCellEditor = editMode;
          })
        }

        DialogManager.emptyPopupGlass();
        DialogManager.addPopupToGlass(this.anchor);

        this.$nextTick(() => {
          inst.$mount();
          this.$nextTick(() =>{
            this.$refs.cellEditorBody.appendChild(inst.$el);
            this.$refs.cellEditorBody.focus();
            if (inst.focus) {
              this.$nextTick(() => inst.focus());
            }
          })
        });
        this.editedCell = cell;
        cell.classList.add("cell-glow");
      }
    },

    editorKeyDown(event) {
      if (event.key === "Escape") {
        this.cancelEdit(true);
      }
    },
    resetSelectonAndVScroll() {
      if (this.v3) {
        this.$refs.baseGrid.resetSelectonAndVScroll();
      }
    },
    onBackButton() {
      if (this.editorMode) {
        // console.log("BACK")
        this.cancelEdit(true);
      }
    },


    editorFocusOut(event) {
      // console.log("focus  " + event.relatedTarget);
      if (!this.$refs?.cellEditorBody.contains(event.relatedTarget)) {
        if (this.cancelHidingGridCellEditor)
          this.cancelEdit(false);
        else
          this.cancelEdit(true);
      }
    },

    cancelEdit(state) {
      if(this.editorMode) {
        this.editorMode = !state; // true do zatrzymania ukrycia okienka multiedycji !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      }
    },

    commitEdit(data) {
      if (this.beforCellCommit) {
        if (!this.beforCellCommit({...this.editorConf, value: data})) {
          this.editorMode = false;
          return;
        }
      }

      let row = this.editorConf.rowData;
      let prop = this.editorConf.columnConfig.prop;
      row[prop] = data;
      this.refreshRow(row);

      this.editorMode = false;
    },

    cleanEditor() {
      this.editedCell?.classList.remove("cell-glow");
      this.editedCell = null;
      DialogManager.emptyPopupGlass();
      if (this.editorInst) {
        this.$refs?.cellEditor.replaceChildren();
        let idx = this.$children.findIndex(el => el == this.editorInst);
        this.$children.splice(idx, 1);
        this.editorInst.$destroy();
        this.editorInst.$root = null;
        this.editorInst = null;
      }
    },

    _itemDoubleClick() {

      // return true;

      if (this.localSelectedItem?.__row_conf?.readOnly) {
        return;
      }
      if (this.localSelectedItem &&
          this.dblClickEnabled
      ) {
        this.$emit('row-dblclicked', this.localSelectedItem);
        return;
      }
    },
    _rowIndexToItemIndex(idx) {
      const item = this._rowIndexToItem(idx);
      if (!item) {
        return item;
      }

      let res = this.items.indexOf(item);
      if (res < 0) {
        return null;
      }
      return res;
    },

    _rowIndexToItem(idx) {
      if (idx === undefined || idx === null) {
        return null;
      }
      const items = this.gridData.dataStore.get('items');
      const source = this.gridData.dataStore.get('source');
      if (source.hasOwnProperty("get")) {
        return source.get(items[idx]);
      }
      return source[items[idx]];
    },

    _rowIndexAndColIndexToItemForDynamicColumns(col, idx) {

      const itemsRow = this.gridData.dataStore.get('items');
      const sourceRow = this.gridData.dataStore.get('source');

      let colId = col.id;
      let rowId = sourceRow[itemsRow[idx]].id;
      let result = null;

      for (const cell of this.dynamicCells) {
        if (colId === cell[this.dynamicCellFormConfig.columnFieldForDynamicColumns] && rowId === cell[this.dynamicCellFormConfig.rowFieldForDynamicColumns]) {
          result = cell;
          break;
        }
      }
      return result;
    },

    _setItemFromDynamicColumns(col, row) {
      let colId = col.id;
      let rowId = row.id;
      let result = null;

      for (const cell of this.dynamicCells) {
        if (colId === cell[this.dynamicCellFormConfig.columnFieldForDynamicColumns] && rowId === cell[this.dynamicCellFormConfig.rowFieldForDynamicColumns]) {
          result = cell;
          break;
        }
      }
      return result;
    },

    _reload() {
      this.$emit('reload');
    },

    pushRow(rowData, focus = true) {
      this.items.push(rowData);
      this.refreshItems();
    },

    removeOne(idOrPredicate) {
      if (typeof idOrPredicate === "function") {
        _.remove(this.items, idOrPredicate);
      } else {
        _.remove(this.items, (el) => {
          return el.id === idOrPredicate
        });
      }
      this.refreshItems();
    },

    refreshRow(row) {
      this.refreshItems();
    },

    refreshIndex(idx) {
      this.refreshItems();
    },

    removeIndex(rowIndex) {
      //todo
    },
    removeRow(row) {
      //todo
    },

    refreshGrid() {
      this.$refs.rf.refresh();

    },

    async refreshItems() {

      await this.filteredItems.refresh();
      if (this.selectMode === "range" && this.showMultiSelect) {
        await this._updateRangeSelection();
        return;
      }
    },

    _getFocus() {
      return this.getGridSelection()?.selectionStore.get("focus") || this.getAltGridSelection()?.selectionStore.get("focus");
    },

    _getRange() {
      return this.getGridSelection()?.selectionStore.get("range") || this.getAltGridSelection()?.selectionStore.get("range");
    },


    _cleanSelection() {
      if (this.streamingEngine) {
        this.streamingEngine.clearSelection();
        this.streamingEngine.unselectAll();
        this.selectionSize = 0;
        this._updateCanDelete();
        this.localSelectedItems = [];
        this._updateRangeSelection();
        return;
      }
      this.selectionSize = 0;
      this._updateCanDelete();

      this.localSelectedItems = [];
      this.items.forEach(item => {
        if (item.__meta__) {
          item.__meta__.selected = false;
        }
      });
      this._updateRangeSelection();
    },

    refresh() {
      if (this.streamingEngine) {
        setTimeout(() => {
          this.streamingEngine.reload();
        });
      } else {
        this.filteredItems?.refresh();
      }
    },

    async _updateCanDelete() {
      let deleteEnabled = true;
      let rowsEditable = true;
      if (this.form != null && this.form.isView) {
        return;
      }
      if (!this.localSelectedItems) {
        return;
      }
      let src = this.localSelectedItems;
      if (this.localSelectedItems.materialize) {
        src = this.localSelectedItems.knownSelected;
      }

      const defaultSupl = {canDelete: true, editable: true};
      for (let el of src) {
        let item = el[1];
        let masterEntity = null;
        if (this.form?.isView) {
          let masterClass = this.form.masterClass;
          let id = item.id;
          masterEntity = await Rpc.Forms.getExtendedEntity(masterClass, id).lock();
        } else {
          masterEntity = item;
        }
        const supl = masterEntity?.__supplement__ ?? defaultSupl;
        if (supl?.canDelete === false || !(supl?.editable ?? true)) {
          deleteEnabled = false;
          rowsEditable = false;
          break;
        }
      }
      this.canDelete = deleteEnabled;
      this.rowsEditable = rowsEditable;
    },

    async _updateRangeSelection() {
      if (!this.showMultiSelect) {
        this.localSelectedItems = [];
      } else {
        if (this.streaming && this.streamingEngine) {
          this.localSelectedItems = await this.streamingEngine.getSelectedItems();
        } else {
          this.localSelectedItems = this.items.filter(item => item.__meta__?.selected);
        }
      }
      this.selectionSize = this.localSelectedItems.length;
      this._updateCanDelete();

      this.$emit("update:selectionSize", this.selectionSize);

      this.selectionModel = null;
      this.selectionModel = this.localSelectedItems;

      nextTick(() => {
        this.$emit('update:selectedItems', this.localSelectedItems);

        this.$emit('update:selectedIndices', this.localSelectedIndices);

        this.$emit('model-change', this.selectionModel);
      });
    },

    _updateSelection(ignoreDblClick) {
      this.focusEventQueued = false;

      if (this.selectMode === "range" && this.showMultiSelect) {
        this._updateRangeSelection();
        return;
      }

      if (ignoreDblClick === undefined) {
        ignoreDblClick = false;
      }

      let lastSelected = this.localSelectedItem;

      let cellPosition = this._getFocus();

      if (cellPosition == null) {

        this.localSelectedItem = null;
        this.localSelectedItems = null;
        this.localSelectedIndex = null;
        this.localSelectedIndices = null;
        this.selectionSize = 0;
        this.$emit("update:selectionSize", this.selectionSize);
        this._updateCanDelete();

        this.$emit('selection-clear', this.selectedItem);
      } else {

        this.localSelectedItem = this._rowIndexToItem(cellPosition.y);
        this.localSelectedItems = [];

        this.localSelectedIndex = this._rowIndexToItemIndex(cellPosition.y);
        this.localSelectedIndices = [];

        let range = this._getRange();

        for (let y = range.y; y <= range.y1; y++) {
          this.localSelectedItems.push(this._rowIndexToItem(y));
          this.localSelectedIndices.push(this._rowIndexToItemIndex(y));
        }
        this.selectionSize = this.localSelectedItems.length;
        this.$emit("update:selectionSize", this.selectionSize);
        this._updateCanDelete();

        this.$emit('row-selected', this.localSelectedItem);
        this.$emit('rows-selected', this.localSelectedItems);

        this.$emit('row-index-selected', this.localSelectedIndex);
        this.$emit('rows-indices-selected', this.localSelectedIndices);

        this.selectionModel = null;
      }
      if (this.selectMode === "single") {
        this.selectionModel = this.localSelectedItem;
      } else {
        this.selectionModel = this.localSelectedItems;
      }

      nextTick(() => {
        this.$emit('update:selectedItem', this.localSelectedItem);
        this.$emit('update:selectedItems', this.localSelectedItems);

        this.$emit('update:selectedIndex', this.localSelectedIndex);
        this.$emit('update:selectedIndices', this.localSelectedIndices);

        this.$emit('model-change', this.selectionModel);
      });

      if (this.dblClickEnabled) {
        this.selectionTimer = performance.now();
      }
    },


    _beforeSort(e) {
      if (this.beforeSorting) {
        if (false === this.beforeSorting(e)) {
          return;
        }
      }
      // Otwiera sie plik Entities List czyli otwierasz jakakolwiek liste
      // Zawsze odczytywany będzie z session managara te filtry i one przyjdą i tam będzie zapisany ten gridId
      // if(this.$refs.grid.gridId === config.gridId){}

      setTimeout(() => {
        if (this.afterSorting) {
          if (false === this.afterSorting(e)) {
            return;
          }
        }
        this._updateSelection(true);
      });
    },

    refreshHeaders() {
    },

    getGridId() {
      return this._getColumnsManager().configId;
    },

    /**
     * @param streamData {DataStream}
     */
    startStream(engine, streamData) {
      //this.filteredRows = [];
      this.$nextTick(() => {
        this.streamingEngine = engine;
        this.filteredRows = streamData.getResultArray();
      });
    },

    refreshStream(streamData) {
      this.filteredRows = streamData.getResultArray();
    },

    async fillCellsOfDynamicColumns() {
      this.dynamicColumns.forEach(column => {
        let foundSupplementObject = null;
        for (let item of this.filteredItems.data) {
          let listOfSupplements = item?.__supplement__?.dynamicColumns;
          if (listOfSupplements) {
            Object.keys(listOfSupplements).forEach((key) => {
              if (column.columnEntity.id === key) {
                foundSupplementObject = listOfSupplements;
              }
            });
          }
          if (foundSupplementObject) {
            let foundSupplementValue = foundSupplementObject[column.columnEntity.id];
            Vue.set(item, "__" + column.columnEntity.id + "__", foundSupplementValue)
          }
        }
      })
    },

    async fillCellsOfDynamicColumnsWithStreaming() {
      this.dynamicColumns.forEach(column => {
        let foundSupplementObject = null;
        for (let item of this.localArrayOfRecords) {
          let listOfSupplements = item?.__supplement__?.dynamicColumns;
          Object.keys(listOfSupplements).forEach((key) => {
            if (column.columnEntity.id === key) {
              foundSupplementObject = listOfSupplements;
            }
          });
          if (foundSupplementObject) {
            let foundSupplementValue = foundSupplementObject[column.columnEntity.id];
            Vue.set(item, "__" + column.columnEntity.id + "__", foundSupplementValue)
          }
        }
      })
    },

    async postProcessStreamRecords(records) {
      if (await checkIfThereAreDynamicFieldsOnTheGrid(this.form)) {
        this.localArrayOfRecords = [];
        for (let i = 0; i < records.length; i++) {
          this.localArrayOfRecords.push(records[i]);
        }
        await this.loadDynamicData();
      }

      await this.streamRowsPostProcess?.(records);
    },

    async loadDynamicData() {
      if (this.filteredRows.length > 0 && await checkIfThereAreDynamicFieldsOnTheGrid(this.form)) {

        if (SessionManager.featureFlagsSet[FeatureFlag.STREAMING_LISTS] && this.form.streamingMode && this.localArrayOfRecords.length <= 0) {
          [this.dynamicRows, this.dynamicRowsFormConfig] = await getRecordsFromDatabaseWithRowsWhenStreaming(this.form, this.form.formClassLong, this.onlyIds ? this.onlyIds : null, this.excludedIds ? this.excludedIds : null);
        } else if (this.localArrayOfRecords.length > 0) {
          this.dynamicRowsFormConfig = FormsLoader.detectFormConfig(this.form.formClassLong)
          this.dynamicRows = [...this.localArrayOfRecords];
        } else {
          if (this.detailsMasterId !== null) {
            [this.dynamicRows, this.dynamicRowsFormConfig] = await getFilteredRecordsFromDatabaseWithRows(this.form, this.detailsMasterId);
          } else {
            [this.dynamicRows, this.dynamicRowsFormConfig] = await getAllRecordsFromDatabaseWithRows(this.form.formClassLong);
          }
        }
        [this.dynamicCells, this.dynamicCellFormConfig] = await getAllRecordsFromDatabaseWithDynamicCells(this.form.dynamicCells, this.dynamicRows);
        if (this.dynamicCells.length > 0) {
          [this.dynamicColumns, this.dynamicColsFormConfig, this.uniqueDataForColoringDynamicColumns] =
              await getAllRecordsFromDatabaseWithDynamicColumns(this.form.dynamicColumns, this.dynamicCells, this.dynamicCellFormConfig);
        }
        if (this.dynamicColumns.length > 0) {
          if (!this.streaming) {
            await this.fillCellsOfDynamicColumns()
          } else {
            await this.fillCellsOfDynamicColumnsWithStreaming()
          }
        }
      }
    },
  },

  props: {
    initialStyle: {default: ""},
    name: String,
    rowDblclicked: Function,
    rowSelected: Function,
    rowsSelected: Function,
    rowIndexSelected: Function,
    rowsIndicesSelected: Function,
    selectionClear: Function,
    beforeSorting: Function,
    afterSorting: Function,

    reload: Function,
    editable: {type: Boolean, default: false},
    listOfDynamicPreparedObjectForColumns: {type: Array, default: () => []},
    reloadDataForDynamicTab: {default: null},

    dblClickEnabled: {type: Boolean, default: false},
    selectMode: {type: String, default: "single"}, // single

    showHeader: {type: Boolean, default: true},
    headerShowReload: {type: Boolean, default: false},
    headerShowSearch: {type: Boolean, default: true},
    deleteEnabled: {type: Boolean, default: true},
    editMultiSelectFromTab: {default: false},

    searchBarClass: {type: String, default: ""},
    items: {type: Array, default: () => []},
    /** @type {ColumnDefinition[]} */
    columns: {type: Array, default: null},

    /* sync back props */
    selectedItem: {type: Object, default: null},
    selectedItems: {type: Array, default: null},
    selection: {default: null},
    selectedIndex: {type: Number, default: null},
    selectedIndices: {type: Array, default: null},
    filtersColsClasses: {type: String, default: "col-auto"},
    metaStatus: {type: Boolean, default: false},
    detailsMasterId: {default: null},
    eligibleFields: {default: null},

    showAdd: {type: Boolean, default: false},
    showDelete: {type: Boolean, default: false},
    showDetails: {type: Boolean, default: true},
    filteringMode: {default: false},
    addEnabled: {type: Boolean, default: true},
    showColumns: {default: true},
    toolbox: {default: null},
    recordsWithChosenFilters: {default: null},

    onlyIds: {default: null, type: Array, required: false},
    excludedIds: {default: null, type: Array, required: false},

    multiSelectAutoOn: {default: false},
    form: {type: BaseFormConfig},
    dataForSummaryRow: {type: Array, default: () => []},
    streamRowsPostProcess: {default: null},
    context: {default: null},
  },
  watch: {
    // toolbox: async function (val) {
    //   console.log(val);
    // },
    editable: function (newVal) {
      if (!newVal) {
        this.gridData?.classList.remove("grid-editable");
        this.editorMode = false;
        this.addIcons = false;
        this.refreshHeaders();

        window.removeEventListener("scroll", this.scroll, true);

      } else {
        // this.scroll = (event) => {
        //   this.cancelEdit();
        // }

        window.addEventListener("scroll", this.scroll, true);

        if (!this.sizeListener) {
          this.sizeListener = el => this.fixGlassSize(el);
          this.fixGlassSize(null);
          // setTimeout(() =>
          //     addListener(this.$refs.holder, this.sizeListener)
          // );
        }

        this.addIcons = true;
        this.refreshHeaders();
        this.gridData?.classList.add("grid-editable");
      }
    },
    editorMode: function (newVal) {
      this.fixGlassSize();
      if (!newVal) {
        this.cleanEditor();
      }
    },
    streaming: {
      handler: function (newVal, oldVal) {
        this.filteredItems.refresh();
        if (!newVal) {
          setTimeout(() => {
            this.reinstallObserver();
          });
          setTimeout(() => {
            if (this.recordsWithChosenFilters) {
              this.selectRange()
            }
          }, 200);
        }
      }
    },
    items: {
      handler: async function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.counter += 1
          if (await checkIfThereAreDynamicFieldsOnTheGrid(this.form) && this.counter === 2) {
            [this.dynamicCells, this.dynamicCellFormConfig] = await getAllRecordsFromDatabaseWithDynamicCells(this.form.dynamicCells, this.dynamicRows);
            if (this.dynamicCells.length > 0) {
              [this.dynamicColumns, this.dynamicColsFormConfig, this.uniqueDataForColoringDynamicColumns] =
                  await getAllRecordsFromDatabaseWithDynamicColumns(this.form.dynamicColumns, this.dynamicCells, this.dynamicCellFormConfig);
            }
            this.counter = 0
          }
        }

        await this.filteredItems.refresh();
        if (!this.streaming && await checkIfThereAreDynamicFieldsOnTheGrid(this.form)) {
          await this.fillCellsOfDynamicColumns()
        } else if (await checkIfThereAreDynamicFieldsOnTheGrid(this.form)) {
          await this.fillCellsOfDynamicColumnsWithStreaming()
        }

        setTimeout(() => {
          this.reinstallObserver();
        });
        setTimeout(() => {
          if (this.recordsWithChosenFilters) {
            this.selectRange()
          }
        }, 200);
      },
    },
    headerShowReload: (newVal, oldVal) => {
      this.gridHeader.showReload = newVal;
    },

    // searchBarClass: (newVal, oldVal) => {
    //   this.gridHeader.searchBarClass = newVal;
    // },
    showHeader: (newVal, oldVal) => {
      if (newVal) {
        this.gridHeader.classList.add("d-none");
      } else {
        this.gridHeader.classList.remove("d-none");
      }
    },
    metaStatus: function () {
      this.colsVersion++;
    },
    selectMode: function (val) {
      this._getColumnsManager().multiSelectEnabled = (val === 'range' && this.showMultiSelect);
      this.colsVersion++;
      this._cleanSelection();
    },
    showMultiSelect: function (val) {
      this._getColumnsManager().multiSelectEnabled = (this.selectMode === 'range' && this.showMultiSelect);
      this.colsVersion++;
      this._cleanSelection();
      this.$emit("update:showMultiSelect", this.showMultiSelect);

      // this.$emit("update:showMultiSelect2", val); // do zakomentowania ew.
      // if(this.v3){
      //   this.$nextTick(()=>{
      //     this.$refs.baseGrid.updateSelectedRow();
      //   });
      // }
    },
    editMultiSelectFromTab: function (val) {
      this.showMultiSelect = val;
    },
    filteredRowsLength: async function (val, oldVal) {
      if (this.form && !this.form.streamingMode) {
        await this.loadDynamicData();
      }
    },
    reloadDataForDynamicTab: async function (val, oldVal) {
      await this.refreshDynamicColumns();
    },
  },
  model: {
    prop: 'selection',
    event: 'model-change'
  },
  computed: {
    filteredRowsLength() {
      return this.filteredRows.length
    },
    renderedColumns: function () {
      let computedCols = this._getColumnsManager().processColumns(this.colsVersion, this.form);
      //console.log("Adjsting cols");
      this.headerSizeClass = this._setHeaderClass(computedCols);
      let pinned = false;
      for (let c of computedCols) {
        if (c.pin === 'colPinStart') {
          pinned = true;
          break;
        }
      }

      if (this.pinned != pinned) {
        this.pinned = pinned;
        setTimeout(() => {
          this.reinstallObserver();
        })
      }
      this.pinnedCols = this._getColumnsManager().config?.pinnedCols ?? 0;

      return computedCols;
    }
  },
  data: function () {
    return {
      baseStyle: this.initialStyle ?? "",
      v3: false,
      streamingEngine: null,
      columnData: null,
      activeColId: null,
      pinnedCols: 0,
      streaming: false,
      arrowPosition: "up",
      editArrowLeft: "30px",
      glassSize: "",
      cellEditorPos: "",
      editorMode: false,
      height: 100,
      workspaceRoot: null,
      activityRootDiv: null,
      headerSizeClass: '',

      /** @type {RevogrFocus} */
      gridSelection: null,
      /** @type {RevogrData} */
      gridData: null,
      /** @type {RevogrHeader} */
      gridHeader: null,
      /** @type {RevogrOverlaySelection} */
      gridOverlaySelection: null,
      focusEventQueued: false,

      localSelectedItem: null,
      localSelectedItems: null,
      localSelectedIndex: null,
      localSelectedIndices: null,
      selectionModel: null,
      selectionTime: null,
      selectionSize: 0,
      canDelete: true,
      colsVersion: 0,
      filteredItems: new VirtualArray(null),
      filteredRows: [],
      showMultiSelect: false,
      rowsEditable: true,
      cancelHidingGridCellEditor: false,
      dynamicColumns: [],
      dynamicRows: [],
      dynamicCells: [],
      dynamicColsFormConfig: null,
      dynamicRowsFormConfig: null,
      dynamicCellFormConfig: null,
      counter: 0,
      localArrayOfRecords: [],
      searchOn: false,
    }
  }
}
</script>

<style scope>
/*revo-grid[theme=material] revogr-viewport revogr-header {*/
/*  line-height: 80px;*/
/*}*/

/*revo-grid[theme=material] revogr-viewport revogr-header .header-row{*/
/*  height: 80px;*/
/*}*/

revo-grid[theme=material].large-header revogr-viewport revogr-header {
  line-height: 80px;
}

revo-grid[theme=material].large-header revogr-viewport revogr-header .header-row {
  height: 80px;
}

revo-grid[theme=material].medium-header revogr-viewport revogr-header {
  line-height: 60px;
}

revo-grid[theme=material].medium-header revogr-viewport revogr-header .header-row {
  height: 60px;
}

revo-grid[theme=material].small-header revogr-viewport revogr-header {
  line-height: 49px;
}

revo-grid[theme=material].small-header revogr-viewport revogr-header .header-row {
  height: 49px;
}

revo-grid[theme=material] revogr-viewport revogr-header .data-header-cell {
  display: flex;
  align-items: center;
  overflow: visible;
  text-overflow: ellipsis;
}

revo-grid[theme=material] .header-content {
  overflow: visible;
  /* text-overflow: initial; */
  white-space: normal;
  line-height: 18px;
  font-size: 13px;
}
</style>